import React, { Component } from "react";
import { connect } from "react-redux";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import data from "./data.json";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import { noImg, noSig } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import "../reports.css";
import CCCsigs from "./CCCSigs.json";
import otherSigs from "./otherSigs.json";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styled from "styled-components";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";
class SiteSpecificRiskAssessment extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];
        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
        };

        if (path[2] === "reports") {
            props.getReport(
                props.match.params.uid,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                path[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    style={{ width: "100%" }}
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderPhotos(attachedPhotos) {
        const { report } = this.state;
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {report[photo.name]}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {report[photo.date]}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={
                                report[photo.url] === undefined ||
                                report[photo.url] === null ||
                                report[photo.url] === ""
                                    ? noSig
                                    : report[photo.url]
                            }
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: "auto",
                                margin: "0 auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    style={{ width: "100%" }}
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };

    render() {
        //let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let dp = this.renderDropDown;
        let gstyle = gridStyle;
        let cstyle = cellStyle;
        let checkRowCount = 2;
        const { editing, report, selectedImg } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Site Specific Risk Assessment Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">
                        Site Specific Risk Assessment Report
                    </Typography>
                </StyledHeader>
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Site Specific Risk Assessment - " +
                                this.props.match.params.report_id
                                    .replace(/_/g, " ")
                                    .replace(/\./g, ":");
                        }}
                        onAfterPrint={() => {
                            document.title = this.state.title;
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        Site Specific Risk Assessment Report
                                    </Typography>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>General Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Created By:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Timestamp</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {report.timestamp
                                                ? report.timestamp
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 5)}>
                                            <b>Location:</b>
                                        </div>
                                        <div style={cstyle(3, 3, 3, 5, true)}>
                                            {rT("location", report.location)}
                                        </div>
                                        <div style={cstyle(3, 5, 3, 9)}>
                                            <b>Time Call Out Recieved:</b>
                                        </div>
                                        <div style={cstyle(3, 7, 3, 9, true)}>
                                            {report.time_call_out_received
                                                ? report.time_call_out_received
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 9, 4, 13)}>
                                            <b>
                                                Method Statement Selected &
                                                outlined to crew:
                                            </b>
                                        </div>
                                        <div style={cstyle(3, 11, 3, 13, true)}>
                                            {dp(
                                                "ms_outlined_to_crew",
                                                report.ms_outlined_to_crew,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 5)}>
                                            <b>Nature of Incident:</b>
                                        </div>
                                        <div style={cstyle(4, 3, 4, 5, true)}>
                                            {rT(
                                                "nature_of_incident",
                                                report.nature_of_incident
                                            )}
                                        </div>
                                        <div style={cstyle(4, 5, 4, 9)}>
                                            <b>Response Time:</b>
                                        </div>
                                        <div style={cstyle(4, 7, 4, 9, true)}>
                                            {report.response_time
                                                ? report.response_time
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 9, 4, 13)}>
                                            <b>Date:</b>
                                        </div>
                                        <div style={cstyle(4, 11, 4, 13, true)}>
                                            {report.date ? report.date : "N/A"}
                                        </div>
                                        <div style={cstyle(5, 1, 7, 3)}>
                                            <b>
                                                Called out by:(please specify)
                                            </b>
                                        </div>
                                        <div style={cstyle(5, 3, 5, 4)}>
                                            <b>Voxpro</b>
                                        </div>
                                        <div style={cstyle(5, 4, 5, 7, true)}>
                                            {rT("voxpro", report.voxpro)}
                                        </div>
                                        <div style={cstyle(6, 3, 6, 4)}>
                                            <b>Other</b>
                                        </div>
                                        <div style={cstyle(6, 4, 6, 7, true)}>
                                            {rT("other", report.other)}
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13)}>
                                            <b>Start Time:</b>
                                        </div>
                                        <div style={cstyle(5, 10, 5, 13, true)}>
                                            {report.start_time
                                                ? report.start_time
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13)}>
                                            <b>End Time:</b>
                                        </div>
                                        <div style={cstyle(6, 10, 6, 13, true)}>
                                            {report.end_time
                                                ? report.end_time
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 13)}>
                                            <b>Number of staff in crew:</b>
                                        </div>
                                        <div style={cstyle(7, 4, 7, 13, true)}>
                                            {rT(
                                                "number_of_staff_in_crew",
                                                report.number_of_staff_in_crew
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        clear: "both",
                                    }}
                                >
                                    <div style={gstyle(9, 13, null)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Vehicles per 3 minutes</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 4, false)}>
                                            <b>Risk</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, false)}>
                                            <b>Y/N</b>
                                        </div>
                                        <div style={cstyle(2, 7, 2, 10, false)}>
                                            <b>Description</b>
                                        </div>
                                        <div
                                            style={cstyle(2, 10, 2, 13, false)}
                                        >
                                            <b>Photo</b>
                                        </div>

                                        {data.map((f) => {
                                            checkRowCount++;

                                            return (
                                                <React.Fragment
                                                    key={checkRowCount}
                                                >
                                                    <div
                                                        style={cellStyle(
                                                            checkRowCount,
                                                            1,
                                                            checkRowCount,
                                                            4
                                                        )}
                                                    >
                                                        {f.name}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            checkRowCount,
                                                            4,
                                                            checkRowCount,
                                                            7
                                                        )}
                                                    >
                                                        {dp(
                                                            f.risk,
                                                            report[f.risk],
                                                            ["Yes", "No"]
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            checkRowCount,
                                                            7,
                                                            checkRowCount,
                                                            10,
                                                            true
                                                        )}
                                                    >
                                                        {rT(
                                                            f.description,
                                                            report[
                                                                f.description
                                                            ]
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            checkRowCount,
                                                            10,
                                                            checkRowCount,
                                                            13,
                                                            true
                                                        )}
                                                    >
                                                        <img
                                                            src={
                                                                report[
                                                                    f.photo
                                                                ] ===
                                                                    undefined ||
                                                                report[
                                                                    f.photo
                                                                ] === null ||
                                                                report[
                                                                    f.photo
                                                                ] === ""
                                                                    ? noImg
                                                                    : report[
                                                                          f
                                                                              .photo
                                                                      ]
                                                            }
                                                            alt="Risk"
                                                            style={{
                                                                width:
                                                                    "inherit",
                                                                height: "120px",
                                                            }}
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={gstyle(4, 9)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Other Signatures</b>
                                        </div>
                                        {this.renderPhotos(otherSigs)}
                                    </div>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Other Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13)}>
                                            <b>Details of Incident:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 13, true)}>
                                            {rT(
                                                "details_of_incident",
                                                report.details_of_incident
                                            )}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 13)}>
                                            <b>Action Taken:</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 13, true)}>
                                            {rT(
                                                "action_taken",
                                                report.action_taken
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Plant and Materials used:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 13, true)}>
                                            {rT(
                                                "plant_materials_used",
                                                report.plant_materials_used
                                            )}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Contractor Required:</b>
                                        </div>
                                        <div style={cstyle(5, 4, 5, 7, true)}>
                                            {dp(
                                                "contractor_required",
                                                report.contractor_required,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13)}>
                                            <b>Give Details:</b>
                                        </div>
                                        <div style={cstyle(5, 10, 5, 13, true)}>
                                            {rT(
                                                "contractor_details",
                                                report.contractor_details
                                            )}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 13)}>
                                            <b>Follow up requirements:</b>
                                        </div>
                                        <div style={cstyle(6, 4, 6, 13, true)}>
                                            {rT(
                                                "follow_up_requirements",
                                                report.follow_up_requirements
                                            )}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 13)}>
                                            <b>
                                                Which method statements applies
                                                to this Call out Task:
                                            </b>
                                        </div>
                                        <div style={cstyle(7, 4, 7, 13, true)}>
                                            {rT(
                                                "ms_which_applies_to_task",
                                                report.ms_which_applies_to_task
                                            )}
                                        </div>
                                        <div style={cstyle(8, 1, 8, 7)}>
                                            <b>Photograph's Taken:</b>
                                        </div>
                                        <div style={cstyle(8, 4, 8, 7, true)}>
                                            {dp(
                                                "photos_taken",
                                                report.photos_taken,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(8, 7, 8, 13)}>
                                            <b>
                                                Possible Public Liability Claim:
                                            </b>
                                        </div>
                                        <div style={cstyle(8, 10, 8, 13, true)}>
                                            {dp(
                                                "possible_public_liability_claim",
                                                report.possible_public_liability_claim,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(9, 1, 9, 7)}>
                                            <b>Supervisor Called:</b>
                                        </div>
                                        <div style={cstyle(9, 4, 9, 7, true)}>
                                            {dp(
                                                "supervisor_called_out",
                                                report.supervisor_called_out,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(9, 7, 9, 13)}>
                                            <b>Extra Crew Requested:</b>
                                        </div>
                                        <div style={cstyle(9, 10, 9, 13, true)}>
                                            {dp(
                                                "extra_crew_requested",
                                                report.extra_crew_requested,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>
                                                Emergency Services at incident
                                                (tick as appropriate)
                                            </b>
                                        </div>

                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Gardaí:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {dp(
                                                "emergency_services_gardai",
                                                report.emergency_services_gardai,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Civil Defence:</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {dp(
                                                "emergency_services_civil_defence",
                                                report.emergency_services_civil_defence,
                                                ["Yes", "No"]
                                            )}
                                        </div>

                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Medical:</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {dp(
                                                "emergency_services_medical",
                                                report.emergency_services_medical,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>Fire Service</b>
                                        </div>
                                        <div style={cstyle(3, 10, 3, 13, true)}>
                                            {dp(
                                                "emergency_services_fire_service",
                                                report.emergency_services_fire_service,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Ambulance:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 7, true)}>
                                            {dp(
                                                "emergency_services_ambulance",
                                                report.emergency_services_ambulance,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13)}>
                                            <b>Coast Guard:</b>
                                        </div>
                                        <div style={cstyle(4, 10, 4, 13, true)}>
                                            {dp(
                                                "emergency_services_coast_guard",
                                                report.emergency_services_coast_guard,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Other:</b>
                                        </div>
                                        <div style={cstyle(5, 4, 5, 7, true)}>
                                            {dp(
                                                "emergency_services_other",
                                                report.emergency_services_other,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13)} />
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>
                                                Vehicles Involved Reg (if any)
                                            </b>
                                        </div>

                                        <div style={cstyle(2, 1, 2, 7, true)}>
                                            {rT(
                                                "vehicle_1_reg_involved",
                                                report.vehicle_1_reg_involved
                                            )}
                                        </div>

                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            {rT(
                                                "vehicle_2_reg_involved",
                                                report.vehicle_2_reg_involved
                                            )}
                                        </div>

                                        <div style={cstyle(3, 1, 3, 7, true)}>
                                            {rT(
                                                "vehicle_3_reg_involved",
                                                report.vehicle_3_reg_involved
                                            )}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)} />
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={gstyle(4, 9)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>
                                                Cork County Council Signatures
                                            </b>
                                        </div>
                                        {this.renderPhotos(CCCsigs)}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    this.state.reportType
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                            this.props.setActivity(
                                                "update",
                                                "report",
                                                this.state.reportType
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                    {/* {this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit",
                                "report-view"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit"
                            )}
                        >
                            <Button variant="contained">Edit</Button>
                        </Link>
                    )} */}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Additional Notes Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, getJobPackReports, setActivity }
)(SiteSpecificRiskAssessment);
